import { semanticConventions } from "@octopusdeploy/telemetry";
export function pageInstanceTelemetryAttributes(pageId: string, pageInstanceId: string, routeTemplate: string, routeParams: Record<string, string>, pageOwner: string) {
    return {
        [semanticConventions.pageId]: pageId,
        [semanticConventions.pageInstanceId]: pageInstanceId,
        [semanticConventions.pageRouteTemplate]: routeTemplate,
        [semanticConventions.pageOwner]: pageOwner,
        ...getRouteParameterAttributes(routeParams),
    };
}
function getRouteParameterAttributes(routeParams: Record<string, string>) {
    return Object.fromEntries(Object.entries(routeParams).map(([key, value]) => [semanticConventions.getPageRouteParamAttributeName(key), value]));
}
